<template>
  <v-dialog
    v-model="show"
    scrollable
    :overlay="true"
    :max-width="isFullScreen ? '100vw' : '800px'"
    :fullscreen="isFullScreen"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="body-1">
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="!loading.state" class="pa-0">
        <v-carousel
          v-if="parkingFineImages.length"
          v-model="currentSlideIndex"
          :hide-delimiters="parkingFineImages.length === 1"
          :show-arrows="parkingFineImages.length > 1"
          height="100%"
        >
          <v-carousel-item
            v-for="(image, i) in parkingFineImages"
            :key="image.number"
          >
            <img
              :src="image.base64EncodedImage"
              :alt="i"
              style="width: 100%; height: 100%; object-fit: contain;"
              @click="openImageInNewTab(image)"
            />
          </v-carousel-item>
        </v-carousel>
        <div
          v-if="!parkingFineImages.length"
          class="d-flex align-center justify-center"
          :style="isFullScreen ? 'height: 100%' : ''"
        >
          {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.NO_IMAGES_TO_SHOW') }}
        </div>
      </v-card-text>
      <v-toolbar
        v-else-if="loading.state && loading.type === 'getParkingFineImages'"
        class="elevation-0 mt-12"
      >
        <v-spacer></v-spacer>
        <v-progress-circular
          indeterminate
          color="secondary"
        ></v-progress-circular>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="secondary--text"
          text
          @click="isFullScreen = !isFullScreen"
        >
          <v-icon>{{
            !isFullScreen ? 'mdi-arrow-expand-all' : 'mdi-arrow-collapse-all'
          }}</v-icon>
        </v-btn>
        <v-btn color="primary" class="secondary--text" text @click="close()">
          {{ $vuetify.lang.t('$vuetify.CLOSE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ParkingFineImagesDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    parkingFine: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isFullScreen: false,
      currentSlideIndex: 0
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyPress)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyPress)
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
    ...mapGetters('app', ['loading']),
    ...mapGetters('enforcement', ['parkingFineImages'])
  },
  created() {
    this.getParkingFineImages(this.parkingFine.id)
  },
  methods: {
    ...mapActions('enforcement', ['getParkingFineImages']),
    close() {
      this.$store.commit('enforcement/setParkingFineImages', [])
      this.show = false
    },
    openImageInNewTab(image) {
      const newTab = window.open()

      if (newTab) {
        const htmlContent = `
          <!DOCTYPE html>
          <html lang="en">
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Image Preview</title>
            <style>
              html, body {
                margin: 0;
                padding: 0;
                height: 100%;
                background-color: #333;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              img {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
              }
            </style>
          </head>
          <body>
            <img src="${image.base64EncodedImage}" alt="Preview">
          </body>
          </html>
        `

        newTab.document.open()
        newTab.document.write(htmlContent)
        newTab.document.close()
      } else {
        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'error',
            message: 'Failed to open image'
          },
          { root: true }
        )
      }
    },
    onKeyPress(event) {
      if (this.show && event.keyCode === 37) {
        // Left arrow key
        this.prevSlide()
      } else if (this.show && event.keyCode === 39) {
        // Right arrow key
        this.nextSlide()
      } else if (this.show && event.key === 'Escape') {
        this.close()
      }
    },
    prevSlide() {
      if (this.currentSlideIndex > 0) {
        this.currentSlideIndex -= 1
      }
    },
    nextSlide() {
      if (this.currentSlideIndex < this.parkingFineImages.length - 1) {
        this.currentSlideIndex += 1
      }
    }
  }
}
</script>
<style>
img {
  cursor: zoom-in;
}
</style>
